import "./locationPhysicianDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import LocationPhysicianDetailsViewComponent
    from "./location-physician-details-view/locationPhysicianDetailsViewComponent";
import LocationPhysicianDetailsEditComponent
    from "./location-physician-details-edit/locationPhysicianDetailsEditComponent";
import {ImageConfig} from "../../../../constants";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";

interface LocationPhysicianDetailsViewEditComponentProps {
    locationDetails: any;
    onModeChange: Function;
    canEdit: boolean;
}

const LocationPhysicianDetailsViewEditComponent = (props: LocationPhysicianDetailsViewEditComponentProps) => {

    const {locationDetails,onModeChange,canEdit} = props;

    const [mode, setMode] = useState<"view" | "edit">("view");
    const [locationId, setLocationId] = useState<any>(undefined);
    const [physicianList, setPhysicianList] = useState<any>([]);
    const [isPhysicianListLoading, setIsPhysicianListLoading] = useState<boolean>(false);
    const [isPhysicianListLoaded, setIsPhysicianListLoaded] = useState<boolean>(false);
    const [isPhysicianListLoadingFailed, setIsPhysicianListLoadingFailed] = useState<boolean>(false);

    const handlePhysicianDetailsUpdate = useCallback((updatedPhysicianList:any) => {
        setPhysicianList(updatedPhysicianList);
        setMode("view");
    }, []);


    useEffect(() => {
        if (locationDetails) {
            setLocationId(locationDetails.id);
        }
    }, [locationDetails]);

    const getPhysicainList = useCallback(() => {
        const payload = {};
        setIsPhysicianListLoading(true);
        setIsPhysicianListLoaded(false);
        setIsPhysicianListLoadingFailed(false);
        CommonService._location.getPhysicianList(locationId, payload)
            .then((response: IAPIResponseType<any>) => {
                setPhysicianList(response.data);
                setIsPhysicianListLoading(false);
                setIsPhysicianListLoaded(true);
                setIsPhysicianListLoadingFailed(false);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error?.error || `Error while Fetching physician list from the location`, "error");
                setIsPhysicianListLoading(false);
                setIsPhysicianListLoaded(false);
                setIsPhysicianListLoadingFailed(true);
            })
    }, [locationId]);

    useEffect(() => {
        if (locationId) {
            getPhysicainList();
        }
    }, [locationId, getPhysicainList]);

    useEffect(() => {
        onModeChange(mode);
    },[mode,onModeChange])

    const handlePhysicianDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);


    return (
        <div className={'location-details-view-edit-component details-tab-data-wrapper'}>
            {
                isPhysicianListLoading && <div className="details-screen-loading-icon">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isPhysicianListLoadingFailed && <StatusCardComponent title={'Failed to load status'}/>
            }
            {
                isPhysicianListLoaded && <>
                    {
                        mode === "view" && <LocationPhysicianDetailsViewComponent
                            physicianList={physicianList}
                            canEdit={canEdit}
                            onEditModeOpen={() => {
                                setMode("edit")
                            }}
                        />
                    }
                    {
                        mode === "edit" && <LocationPhysicianDetailsEditComponent
                            physicianDetailsList={physicianList}
                            locationId={locationDetails.id}
                            facilityId={locationDetails.facilityId}
                            onUpdateComplete={handlePhysicianDetailsUpdate}
                            onEditCancel={handlePhysicianDetailsEditCancel}
                        />
                    }
                </>
            }
        </div>
    );

};

export default LocationPhysicianDetailsViewEditComponent;